import { GitBranchIcon as GitBranch, TextColumnsIcon as Columns, CodeIcon as Code, QuestionIcon as Question, SealCheckIcon as SealCheck, FingerprintIcon as Fingerprint } from "@phosphor-icons/react";

function Card({ label, value, sub, Icon, color, testid }) {
  return (
    <div className="ml-card p-4 flex items-start justify-between gap-3" data-testid={testid}>
      <div>
        <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">{label}</div>
        <div className="text-2xl font-semibold tabular-nums mt-1">{value}</div>
        {sub && <div className="text-[11px] text-[var(--ml-text-secondary)] mt-0.5">{sub}</div>}
      </div>
      <Icon size={20} weight="duotone" color={color} />
    </div>
  );
}

/** Summary strip for the Field Dependencies page (Iter 41). */
export default function FieldDepsSummaryCards({ summary }) {
  if (!summary) return null;
  const conf = summary.by_confidence || {};
  const refs = summary.references || 0;
  const highPct = refs ? Math.round(((conf.high || 0) / refs) * 100) : 0;
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="fd-summary">
      <Card label="References" value={refs} Icon={GitBranch} color="#0f62fe" testid="fd-total-references" />
      <Card label="Fields" value={summary.fields || 0} sub={`${summary.files || 0} file${(summary.files || 0) === 1 ? "" : "s"} resolved`} Icon={Columns} color="#6929c4" testid="fd-total-fields" />
      <Card label="Programs touching" value={summary.programs || 0} Icon={Code} color="#0e6027" testid="fd-total-programs" />
      <Card label="Ambiguous fields" value={summary.ambiguous_fields || 0} sub={`${summary.ambiguous_references || 0} refs unresolved on purpose`} Icon={Question} color="#8a6d00" testid="fd-total-ambiguous" />
      <Card label="High confidence" value={`${highPct}%`} sub={`${conf.high || 0} high · ${conf.medium || 0} med · ${conf.low || 0} low`} Icon={SealCheck} color="#0e6027" testid="fd-high-confidence" />
      <Card label="Unknown provenance" value={summary.unknown_provenance || 0} sub="no DSPFFD batch behind the row" Icon={Fingerprint} color="#525252" testid="fd-unknown-provenance" />
    </div>
  );
}
